import styled, { css } from 'styled-components';
import colors from 'styles/colors';
import { NavLink } from 'react-router-dom';

const NavMenuItemMixin = css`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5em 1em;
  width: 100%;

  &:hover {
    background-color: ${colors.activeLight};
  }
`;

export const NavMenuItem = styled.div`
  ${NavMenuItemMixin};
`;

export const NavMenuLinkItem = styled(NavLink)`
  ${NavMenuItemMixin};
  text-decoration: none;
  color: inherit;
`;

export const NavMenuSeparator = styled.div`
  margin: 0.75em 1em 0.75em;
  border: 0.75px solid ${colors.gray85};
`;

export const NavMenuCloseButton = styled.div`
  font-size: 0.9em;

  &:hover {
    color: ${colors.gray50};
    cursor: pointer;
  }
`;
